import api from './pipedriveClient';

/** Pipedrive-Feld-Keys (Stressfrei-Vorgangsnummer + Adressen) – wie in TourPlanner. */
const VORGANGSNUMMER_FIELD_KEY = process.env.REACT_APP_PIPEDRIVE_VORGANGSNUMMER_FIELD_KEY || 'b76a77e3550e78343a4b93fc151ff97b4afcc397';
const ORIGIN_ADDRESS_FIELD_KEY = process.env.REACT_APP_PIPEDRIVE_ADDRESS_FIELD_KEY || '07c3da8804f7b96210e45474fba35b8691211ddd';
const DESTINATION_ADDRESS_FIELD_KEY = process.env.REACT_APP_PIPEDRIVE_DELIVERY_ADDRESS_FIELD_KEY || '9cb4de1018ec8404feeaaaf7ee9b293c78c44281';

/**
 * Lädt offene Deals von Pipedrive und baut eine Map: Vorgangsnummer → { originAddress, destinationAddress }.
 * Match: Pipedrive-Deal-Feld "Stressfrei Vorgangsnummer" = Stressfrei-Termin.vorgangsno.
 * @param {string[]} vorgangsnummern - Eindeutige Vorgangsnummern aus Stressfrei-Terminen
 * @returns {Promise<Map<string, { originAddress: string, destinationAddress: string }>>}
 */
export const getAddressesByVorgangsnummern = async (vorgangsnummern) => {
  const set = new Set((vorgangsnummern || []).map((v) => String(v).trim()).filter(Boolean));
  if (set.size === 0) return new Map();

  try {
    const response = await api.get('/deals', { params: { limit: 500, status: 'open' } });
    const deals = response.data?.data || [];
    const map = new Map();

    for (const deal of deals) {
      const raw = deal[VORGANGSNUMMER_FIELD_KEY];
      const vn = raw != null ? String(raw).trim() : '';
      if (!vn || !set.has(vn)) continue;

      const originAddress = (deal[ORIGIN_ADDRESS_FIELD_KEY] || '').trim();
      const destinationAddress = (deal[DESTINATION_ADDRESS_FIELD_KEY] || '').trim();
      map.set(vn, { originAddress, destinationAddress });
    }

    return map;
  } catch (err) {
    console.warn('Pipedrive getAddressesByVorgangsnummern:', err);
    return new Map();
  }
};

export const getDeal = async (dealId) => {
  try {
    const response = await api.get(`/deals/${dealId}`);
    
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to fetch deal');
    }
    
    if (!response.data.data) {
      throw new Error('No deal data found');
    }
    
    return response.data.data;
  } catch (error) {
    console.error('Error fetching deal:', error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

export const addNoteToDeal = async (dealId, content) => {
  try {
    const response = await api.post('/notes', {
      content,
      deal_id: dealId
    });
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to add note to deal');
    }
    return response.data;
  } catch (error) {
    console.error('Error adding note to deal:', error);
    throw error;
  }
};